if (!customElements.get('reviews-slider')) {
  class ReviewsSlider extends HTMLElement {
    constructor() {
      super();
    }

    toggleStateClass(force) {
      this.classList.toggle('is-playing', force);
    }

    restartAnimation() {
      this.classList.remove('animated');
      this.classList.add('animated');
    }

    connectedCallback() {
      const thisRef = this;

      this.options = {
        on: {
          autoplayStart: function () {
            thisRef.toggleStateClass(true);
          },
          autoplayStop: function () {
            thisRef.toggleStateClass(false);
          },
          slideChangeTransitionEnd: function () {
            thisRef.restartAnimation();
          },
        },
        autoplay: {
          delay: this.getAttribute('data-delay'),
          pauseOnMouseEnter: true,
        },
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
        },
      };

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('reviews-slider', ReviewsSlider);
}
